import type { Invoice as RxInvoice } from "$global-providers/rxdb-provider/collections/invoice";
import { Invoice } from "$routes/_lib/billing-v2/invoice";
import type { CalculatedInvoice } from "$routes/_lib/billing-v2/invoice-source";
import type { RxDocument } from "rxdb";
import { invoiceRecordFromDocument } from "./invoice-record-from-document";

export const updateInvoiceDocument = async (
  doc: RxDocument<RxInvoice>,
  {
    timestamp,
    actionedByUserId,
    update,
  }: {
    timestamp: string;
    actionedByUserId: string;
    update: (invoice: Invoice) => CalculatedInvoice;
  },
): Promise<CalculatedInvoice> => {
  const updated = await doc.incrementalModify((latest) => {
    const next = update(Invoice.fromRecord(latest));
    return {
      ...latest,
      ...next,
      meta: {
        ...next.meta,
        updatedAt: timestamp,
        updatedByUserId: actionedByUserId,
      },
    };
  });
  return Invoice.fromRecord(invoiceRecordFromDocument(updated)).toRecord();
};
